import deepmerge from 'deepmerge';
import loadGlobals from './load-files/load-files-globals';
import loadFilesAll from './load-files/load-files-all';
import { Configuration, ConfigurationManifestComponent } from '../typings';
import getFilteredFiles from '../helpers/get-filtered-files';
import EventEmitter from '../event-emitter/event-emitter';

export const LazyLoader = async (
  config: Configuration,
  loadToGlobal = true
) => {
  const coreFiles = getFilteredFiles<ConfigurationManifestComponent>(
    config.files
  );

  await loadGlobals({ config } as any);
  const loadAllFiles = await loadFilesAll({ ...config, files: coreFiles });

  if (loadToGlobal && Object.keys(loadAllFiles as any).length > 0) {
    Object.entries(loadAllFiles as any).forEach(([moduleName, components]) => {
      Object.entries(components as any).forEach(
        ([componentName, component]) => {
          global[moduleName] = deepmerge(global[moduleName], {
            [componentName]: component
          });
        }
      );
    });

    EventEmitter.emit('updateStateLoadedComponents', { loadAllFiles });
  }

  return loadAllFiles;
};
